<template>
  <div class="setting-popup scene-effect-popup"  v-if='boxData.judgeBox' :style="{'top': boxData.fix.y+'px', 'left': boxData.fix.x+'px', 'z-index': boxData.Zindex, }" @mousedown="stopDocument($event)"
    ref="popupRef"
  >
    <div class="setting-popup__drag-area">
      转场动画
    </div>
    <div class="setting-popup__content" style="max-height: 620px;" v-bar>
      <div style="max-height: 640px;">
        <div class="list">
          <template v-for="(category, k) in newEffects">

            <div class="list__title" :key="`title-${k}`">
              {{lang[k]}}
            </div>

            <ul class="list__list" :key="`list-${k}`">
              <template v-for="(item, i) in category">

              <li class="list__item" :key="i"
                :class="{'is-selected': item.selected, 'no-anim': item.type === 'None'}"
                @click="onClickItemNew({ index: i, category: k, needVIP: item.needVIP })"
                v-analysis="ANALYSIS[item.type]"
              >
                <div>
                  <i :title="item.text" v-if="item.type !== 'None'">
                    <span class="title">
                      <i :class="['icon-scene-slide-' + mapIconName(item.type)]"></i>
                      <span>{{item.text}}</span>
                    </span>
                    <span class="anim">
                      <video v-if="item.asset" :src="getAsset(item.asset)"
                        loop
                        @mouseover="playVideo($event)"
                        @mouseout="stopVideo($event)"
                      ></video>
                    </span>
                  </i>
                  <i v-else>
                    <i></i>
                    <span>无动画</span>
                  </i>
                  <div :class="getBadgeClassName(6, 'common-vip-tip')" v-if="item.needVIP" v-show="showVipTip"></div>
                </div>
              </li>
              </template>
            </ul>

          </template>

        </div>

      </div>

    </div>
    <div class="setting-popup__mask" v-show="isShowMask" @click="closeNextPopup('color')"></div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import popup from '../mixins/popup'
import vipBadge from '@/components/mixins/vipBadge';

const myPopup = {
  ...popup,
  watch: {}
}
export default {
  mixins: [
    popup,
    vipBadge
  ],
  props: {
    directionType: {
      type: String,
      default: 'from', // 'form' | 'to'
    }
  },
  data () {
    return {
      ANALYSIS:{
        None: {category:'resource_scene', action:'click_transition_empyt', label:'资源设置_场景_转场_无'},
        LeftIn: {category:'resource_scene', action:'click_transition_left', label:'资源设置_场景_转场_从左移入'},
        RightIn: {category:'resource_scene', action:'click_transition_right', label:'资源设置_场景_转场_从右移入'},
        UpIn: {category:'resource_scene', action:'click_transition_up', label:'资源设置_场景_转场_从上移入'},
        DownIn: {category:'resource_scene', action:'click_transition_down', label:'资源设置_场景_转场_从下移入'},
        ZoomIn: {category:'resource_scene', action:'click_transition_zoom_in', label:'资源设置_场景_转场_放大'},
        ZoomOut: {category:'resource_scene', action:'click_transition_zoom_out', label:'资源设置_场景_转场_缩小'},
        Fade: {category:'resource_scene', action:'click_transition_fade', label:'资源设置_场景_转场_淡入淡出'},
        Clipboard: {category:'resource_scene', action:'click_transition_clipboard', label:'资源设置_场景_转场_电影打板'},
        TvNoise: {category:'resource_scene', action:'click_transition_tv_noise', label:'资源设置_场景_转场_电视雪花'},
        Hands: {category:'resource_scene', action:'click_transition_tv_hands', label:'资源设置_场景_转场_手势下滑'},
        PullDown: {category:'resource_scene', action:'click_transition_pull_down', label:'资源设置_场景_转场_帘子下移'},
        Roller: {category:'resource_scene', action:'click_transition_roller', label:'资源设置_场景_转场_滚筒刷'},
        Sqweegee: {category:'resource_scene', action:'click_transition_sqweegee', label:'资源设置_场景_转场_玻璃刮'},
        Poof: {category:'resource_scene', action:'click_transition_poof', label:'资源设置_场景_转场_爆出'},
        BlueColorSmear: {category:'resource_scene', action:'click_transition_blue_color_mear', label:'资源设置_场景_转场_蓝色涂抹'},
        WhiteColorSmear: {category:'resource_scene', action:'click_transition_white_color_mear', label:'资源设置_场景_转场_白色涂抹'},
        FanUp: {category:'resource_scene', action:'click_transition_white_fan_up', label:'资源设置_场景_转场_扇叶向上'},
        FanDown: {category:'resource_scene', action:'click_transition_white_fan_down', label:'资源设置_场景_转场_扇叶向下'},
        SpiralzTech: {category:'resource_scene', action:'click_transition_white_spiralz_tech', label:'资源设置_场景_转场_蓝色螺旋'},
        Spiralz: {category:'resource_scene', action:'click_transition_white_spiralz', label:'资源设置_场景_转场_灰色螺旋'},
        Swipe: {category:'resource_scene', action:'click_transition_swipe', label:'资源设置_场景_转场_横向划出'},
        SliceVertical: {category:'resource_scene', action:'click_transition_slice_vertical', label:'资源设置_场景_转场_垂直划像'},
        SliceHorizontal: {category:'resource_scene', action:'click_transition_slice_horizontal', label:'资源设置_场景_转场_水平划像'},
        SliceCenter: {category:'resource_scene', action:'click_transition_slice_center', label:'资源设置_场景_转场_中间划像'},
        Slice: {category:'resource_scene', action:'click_transition_slice', label:'资源设置_场景_转场_对角划像'},
        CameraUp: {category:'resource_scene', action:'click_transition_camera_up', label:'资源设置_场景_转场_镜头上移'},
        CameraDown: {category:'resource_scene', action:'click_transition_camera_down', label:'资源设置_场景_转场_镜头下移'},
        CameraLeft: {category:'resource_scene', action:'click_transition_camera_left', label:'资源设置_场景_转场_镜头左移'},
        CameraRight: {category:'resource_scene', action:'click_transition_camera_right', label:'资源设置_场景_转场_镜头右移'},
      },
      popupType: 'sceneEffect',
      scenesMsg: {},

      lang: {
        basic: '基础型',
        stylized: '特效型',
        executive: '华丽型',
        camera: '镜头型',
      },
      assetPath: '/static/video/',

      newEffects: {
        basic: [
          {text: '无动画', type: 'None', selected: false},
          {text: '放大', type: 'ZoomIn', selected: false, asset: 'Zoom In'},
          {text: '缩小', type: 'ZoomOut', selected: false, asset: 'Zoom Out'},
          {text: '淡入淡出', type: 'Fade', selected: false, asset: 'Fade'},

          // 注意: RightIn 指的是终点是 right
          {text: '从左移入', type: 'RightIn', selected: false, asset: 'Slide Right'},
          {text: '从右移入', type: 'LeftIn', selected: false, asset: 'Slide Left'},
          {text: '从上移入', type: 'DownIn', selected: false, asset: 'Slide Down'},
          {text: '从下移入', type: 'UpIn', selected: false, asset: 'Slide Up'},
        ],
        stylized: [
          {text: '手势下移', type: 'Hands', selected: false, asset: 'Hands'},
          {text: '白色涂抹', type: 'WhiteColorSmear', selected: false, asset: 'White Color Smear'},
          {text: '电影打板', type: 'Clipboard', selected: false, asset: 'Clipboard', needVIP: true},
          {text: '电视雪花', type: 'TvNoise', selected: false, asset: 'TV Noise', needVIP: true},
          {text: '帘子下移', type: 'PullDown', selected: false, asset: 'Pull Down', needVIP: true},
          {text: '滚筒刷', type: 'Roller', selected: false, asset: 'Roller', needVIP: true},
          {text: '玻璃刮', type: 'Sqweegee', selected: false, asset: 'Sqweegee', needVIP: true},
          {text: '爆出', type: 'Poof', selected: false, asset: 'Poof', needVIP: true},
          {text: '蓝色涂抹', type: 'BlueColorSmear', selected: false, asset: 'Blue Color Smear', needVIP: true},
        ],
        executive: [
          {text: '横向划出', type: 'Swipe', selected: false, asset: 'Swipe'},
          {text: '垂直划像', type: 'SliceVertical', selected: false, asset: 'Slice Vertical'},
          {text: '扇叶向上', type: 'FanUp', selected: false, asset: 'Fan Up', needVIP: true},
          {text: '扇叶向下', type: 'FanDown', selected: false, asset: 'Fan Down', needVIP: true},
          {text: '蓝色螺旋', type: 'SpiralzTech', selected: false, asset: 'Spiralz Tech', needVIP: true},
          {text: '灰色螺旋', type: 'Spiralz', selected: false, asset: 'Spiralz', needVIP: true},
          {text: '水平划像', type: 'SliceHorizontal', selected: false, asset: 'Slice Horizontal', needVIP: true},
          {text: '中间划像', type: 'SliceCenter', selected: false, asset: 'Slice Center', needVIP: true},
          {text: '对角划像', type: 'Slice', selected: false, asset: 'Slice', needVIP: true},
          {text: '翻书', type: 'FlipBook', selected: false, asset: 'FlipBook', needVIP: true},
          {text: '行铺', type: 'RowSpread', selected: false, asset: 'RowSpread', needVIP: true},
          {text: '像素溶解', type: 'Mosaic', selected: false, asset: 'Mosaic', needVIP: true},
        ],
        camera: [
          {text: '镜头上移', type: 'CameraUp', selected: false, asset: 'Camera Up'},
          {text: '镜头下移', type: 'CameraDown', selected: false, asset: 'Camera Down', needVIP: true},
          {text: '镜头左移', type: 'CameraLeft', selected: false, asset: 'Camera Left', needVIP: true},
          {text: '镜头右移', type: 'CameraRight', selected: false, asset: 'Camera Right', needVIP: true},
        ]
      },
      showVipTip: false
    }
  },
  computed: {
    ...mapGetters([
      'UserLevelType',
      'UserLevel',
      'isPersonVip',
      "TopNav_Size"
    ])
  },
  watch: {
    'boxDatas.firstDatas': function (val) {
      if (this.TOOL && this.boxData.judgeBox ) {
        this.scenesMsg = this.boxData.data.scenesMsg;
        this.update();
        this.setBadges();

        this.$nextTick(() => {
          let winh = this.Window_Size.height;
          let top = this.boxData.fix.y
          if(top < this.TopNav_Size.height) {
            this.boxData.fix.y = this.TopNav_Size.height
          }
          if(top + 680 > winh) {
            this.boxData.fix.y = winh - 660;
          }

          this.showSelectedByScroll();
        });
      }
    }
  },

  created () {
    this.$bus.on('undoRedoHandle', ({type, mod} = {}) => {
      if (type === 'updateScenesEffect') {
        this.update();
      }
    })
  },

  methods: {
    update (category) {
      let { newEffects } = this;
      let { beforeEffect, afterEffect } = this.scenesMsg;

      for (let cate in newEffects) {
        if (Array.isArray(newEffects[cate])) {
          newEffects[cate].forEach((item) => {
            item.selected = false;
          });
          let eff = this.getEffectNew(beforeEffect.effect.code);
          (eff || {}).selected = true;
        }
      }
    },
    getEffectNew (code) {
      const { newEffects } = this;
      for (let cate in newEffects) {
        if (Array.isArray(newEffects[cate])) {
          let eff = newEffects[cate].filter((item) => item.type === code)[0];
          if (eff) {
            return eff;
          }
        }
      }
    },
    onClickItemNew ({
      index,
      category,
      needVIP
    } = {}) {
      let { beforeEffect, afterEffect } = this.scenesMsg;
      let { type: willSetCode, badge } = this.newEffects[category][index];
      if (needVIP && this.showVipTip) {
        // this.$bus.emit('FeaturesPop_vue', {
        //   name   : "vipEquity",
        //   msg    : '升级为会员后，可使用更多转场动画。',
        //   type   : 2,
        //   btnMsg : '升级会员免费用',
        //   btnMsgLink  : '/vipsolo',
        //   baiduAction : 'upgradeAidubVip',
        // });

        // this.$modal.show("vipDialog", {
        //   msg: '升级为个人VIP，可使用更多转场动画。',
        //   target: "vipsolo",
        //   type: "solo",
        // });
        // return;
      }
      // this.$bus.emit('FeaturesPop_close_vue', {
      //   name   : "vipEquity",
      //   type   : 2,
      // });
      this.$modal.hide('vipDialog');

      if (beforeEffect.effect.code === willSetCode) {
        return;
      }
      beforeEffect.updateEffect({code: willSetCode, manual: 1}, true);
      beforeEffect.effect.init();
      this.update();
      // this.$bus.emit('SettingScenesEffect', beforeEffect.effect.code, beforeEffect.index, beforeEffect.id)
    },
    getAsset (name) {
      return `${this.assetPath}${name}.mp4`;
    },
    playVideo (ev) {
      const el = ev.currentTarget;
      if (el.paused) {
        el.play();
      }
    },
    stopVideo (ev) {
      const el = ev.currentTarget;
      if (el) {
        el.pause();
        el.currentTime = 0;
      }
    },
    setBadges () {
      if (this.UserLevelType < 2 && !this.isPersonVip) {
        this.showVipTip = true;
      } else {
        this.showVipTip = false;
      }
    },
    setBadges_ (val) {
      const { newEffects } = this;
      for (let cate in newEffects) {
        if (Array.isArray(newEffects[cate])) {
          newEffects[cate].forEach((item) => {
            if (item.needVIP) {
              this.$set(item, 'badge', val);
            }
          })
        }
      }
    },
    mapIconName (type) {
      let m = {
        RightIn: 'LeftIn',
        LeftIn: 'RightIn',
        DownIn: 'UpIn',
        UpIn: 'DownIn'
      }
      return m[type] || type;
    },
    showSelectedByScroll () {
      const ele = $('.scene-effect-popup .is-selected')[0];
      if (!ele) return;
      const wrapperRect = $('.scene-effect-popup .setting-popup__content')[0].getBoundingClientRect();
      const rect = ele.getBoundingClientRect();
      if (rect.bottom < wrapperRect.top || rect.top > wrapperRect.bottom) {
        ele.scrollIntoView();
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../style/colors";

  .setting-popup {
    position: absolute;
    top: 0;
    left: 0;
    width: 380px;
    max-height: 680px;
    z-index: 35;
    border-radius: 6px 6px 3px 3px;
    background: #fff;
    overflow: hidden;
    font-size: 14px;
    box-shadow: 0 0 3px 1px #d8dee9;
    color: #474261;

    &__drag-area {
      line-height: 28px;
      background: #d8dee9;
      text-align: left;
      text-indent: 14px;
    }

    &__close {
      position: absolute;
      top: 7px;
      right: 12px;
      height: 14px;
      line-height: 14px;
      width: 14px;
      cursor: pointer;
    }

    &__content {
      & > div {
        overflow-x: hidden !important;
        &:before, &:after {
          content: ' ';
          display: block;
          // height: 14px;
        }
      }
    }

    &__mask {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background-color: rgba(#ffffff, 0.7);
    }
  }

  .list {
  padding: 9px;
  padding-left: 13px;
  padding-right: 13px;
  >ul {
    display: flex;
    flex-wrap: wrap;
    // justify-content: space-between;
    align-items: center;
    margin-left: 1px;
  }
  &__title {
    padding-bottom: 10px;
    padding-top: 10px;
    text-align: left;
  }
  &__item {
    margin-top: 12px;
    margin-right: 11px;
    cursor: pointer;
    &:nth-child(3n) {
      margin-right: 0;
    }
    &:nth-child(1), &:nth-child(2), &:nth-child(3) {
      margin-top: 0;
    }

    >div {
      position: relative;
    }

    >div>i, >div>span {
      box-sizing: border-box;
      display: inline-block;
      width: 110px;
      height: 58px;
      border-radius: 4px;
      background-color: $c6;
      overflow: hidden;
      font-style: normal;

      & > .title {
        visibility: visible;
        display: flex;
        justify-content: center;
        align-items: center;
        width: 100%;
        height: 100%;

        > i {
          margin-right: .7em;
        }
      }

      & > .anim {
        display: none;
        visibility: hidden;
        // display: flex;
        justify-content: center;
        align-items: center;
        width: 100%;
        height: 100%;
      }
    }

    &.no-anim {
      >div > i {
        display: flex;
        justify-content: center;
        align-items: center;
      }
      > div > i > i {
        display: inline-block;
        position: relative;
        width: 28px;
        height: 24px;
        overflow: hidden;
        background-color: #ffffff;
        margin-right: 10px;
        &:before {
          content: " ";
          position: absolute;
          height: 1px;
          width: 130px;
          background-color: red;
          transform: rotate(-42deg) translatex(-38px) translatey(-35px);
        }
      }
    }

    &.is-selected {
      >div > i {
        // border: 1px solid $c2;
        box-shadow: 0 0 0 1.5px $c2;
      }
    }

    &:hover {
      > div > i {
        > .title {
          display: none;
          visibility: hidden;
        }
        > .anim {
          display: flex;
          visibility: visible;
        }
      }
    }
  }
}


.common-vip-tip {
  position: absolute;
  top: -8px;
  left: 81px;
  width: 36px;
  height: 16px;
  background-image: url(../../../static/svg/payTypeSubscript/vip36x16.svg);
  background-size: cover;
  background-repeat: no-repeat;
}
.pro {
  position: absolute;
  top: -8px;
  left: 81px;
  width: 30px;
  height: 18px;
  content: url(../../assets/pro.png);
}
</style>




// WEBPACK FOOTER //
// src/components/popups/sceneEffect.vue